import React from 'react';
import { HiOutlineCheckCircle, HiOutlineX } from 'react-icons/hi';

function SuccessModal({ title, message, onClose }) {
  if (!title && !message) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-neutral-900/60 px-4 py-6">
      <div className="w-full max-w-sm rounded-xl border border-gray-100 bg-white p-5 text-center shadow-xl dark:border-neutral-800 dark:bg-neutral-900">
        <button
          type="button"
          onClick={onClose}
          className="ml-auto flex text-gray-400 transition hover:text-gray-700 dark:hover:text-neutral-200"
          aria-label="Close success message"
        >
          <HiOutlineX className="text-xl" />
        </button>
        <div className="mx-auto mt-1 flex h-14 w-14 items-center justify-center rounded-full bg-green-50 text-green-600 dark:bg-neutral-800 dark:text-green-300">
          <HiOutlineCheckCircle className="text-4xl" />
        </div>
        <h2 className="mt-4 text-lg font-bold text-gray-900 dark:text-neutral-100">{title}</h2>
        {message && (
          <p className="mt-2 text-sm text-gray-500 dark:text-neutral-400">{message}</p>
        )}
        <button
          type="button"
          onClick={onClose}
          className="mt-5 w-full rounded-xl bg-blue-500 px-5 py-3 text-sm font-semibold text-white transition hover:bg-blue-600"
        >
          Done
        </button>
      </div>
    </div>
  );
}

export default SuccessModal;
